import { render, staticRenderFns } from "./admins-list.component.html?vue&type=template&id=33528504&scoped=true&"
import script from "./admins-list.component.ts?vue&type=script&lang=ts&"
export * from "./admins-list.component.ts?vue&type=script&lang=ts&"
import style0 from "./admins-list.component.scss?vue&type=style&index=0&id=33528504&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33528504",
  null
  
)

export default component.exports